import { withRouter } from 'react-router-dom';

import MultiStepForm from './MultiStepForm';

export default withRouter(MultiStepForm);
